/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Further_Air_Handler_UnitInputs */



/**
* | output |
* | --- |
* | "Ventilation" |
*
* @param {Go_Further_Air_Handler_UnitInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_air_handler_unit = /** @type {((inputs?: Go_Further_Air_Handler_UnitInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_Air_Handler_UnitInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Ventilation")
	return /** @type {LocalizedString} */ ("Ventilation")
});